
// components/Call.js
import React from 'react';
import { Typography } from '@mui/material';

const Call = () => <Typography variant="h4" align="center" mt={4}>Call</Typography>;

export default Call;
